<template>
    <div>
        <loading :ativo="loading.visivel" :mensagem="loading.mensagem" />
        <table class="tabela tabela_listrada tabela_com-largura-total">
            <thead>
                <tr>
                    <th>Valor</th>
                    <th>Cidade</th>
                    <th>Emenda</th>
                    <th class="u-texto-alinhado-ao-centro">Publicação da emenda</th>
                    <th class="u-texto-alinhado-ao-centro" v-for="faixa in colunasDinamicas" :key="faixa">
                        {{ faixa }}
                    </th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="aporte in aportesLocais" :key="aporte.Id">
                    <td>{{ $moeda.formatar(aporte.ValorDoAporte) }}</td>
                    <td>{{ aporte.NomeDaCidade }}</td>
                    <td>{{ aporte.NumeroDaEmenda }}</td>
                    <td class="u-texto-alinhado-ao-centro">
                        {{ $tempo.formatarParaPadraoBrasileiro(aporte.DataDePublicacaoDaEmenda) }}</td>
                    <td class="u-texto-alinhado-ao-centro" v-for="faixa in colunasDinamicas" :key="faixa">
                        {{ obterPercentualDaFaixa(aporte, faixa) }}
                    </td>
                    <td class="u-texto-alinhado-ao-centro">
                        <button type="button"
                            :class="['botao botao_sem-preenchimento botao_medio botao_cor-terciaria', aporte.PermiteExclusaoDoAporte ? '' : 'u-desabilitado']"
                            :title="aporte.PermiteExclusaoDoAporte ? 'Excluir aporte' : 'Exclusão não permitida'"
                            @click="abrirModalDeExclusao(aporte)">
                            <i class="fal fa-ban" aria-hidden="true"></i>
                        </button>
                    </td>
                </tr>
                <tr v-if="aportesLocais.length === 0">
                    <td colspan="4">Nenhum aporte foi encontrado</td>
                </tr>
            </tbody>
        </table>

        <modal v-if="modalDeExclusaoEstaVisivel" @close="fecharModalDeExclusao">
            <form @submit.prevent="excluirAporte" class="formulario">
                <h3 class="titulo titulo_medio u-margem-inferior-media">Confirma a exclusão do aporte?</h3>
                <hr class="u-margem-inferior-media">
                <div class="grade__linha_alinhar-horizontal-direita formulario-button">
                    <button type="button" @click="fecharModalDeExclusao"
                        class="botao botao_cinza botao_medio u-margem-direita-pequena">Cancelar</button>
                    <button type="submit" class="botao botao_cor-terciaria botao_medio"
                        :class="{ 'is-loading': loading.visivel }">Confirmar</button>
                </div>
            </form>
        </modal>
        <MensagemFlutuante :mensagemVisivel="mensagemVisivel" :titulo="tituloMensagem" :estilo="estiloMensagem"
            :texto="textoMensagem" @close="fecharMensagem" />
    </div>

</template>

<script>
import Modal from '../../shared/Modal';
import Loading from '../../shared/Loading';
import MensagemFlutuante from '../../shared/MensagemFlutuante';

export default {
    name: "TabelaAportes",
    components: { Modal, Loading, MensagemFlutuante },
    props: {
        aportes: {
            type: Array,
            required: true,
        },
    },
    computed: {
        colunasDinamicas() {
            const faixas = new Set();
            this.aportesLocais.forEach(aporte => {
                if (aporte.DistribuicoesDoAportePorFaixa) {
                    aporte.DistribuicoesDoAportePorFaixa.forEach(distribuicao => {
                        faixas.add(distribuicao.NomeDaFaixa);
                    });
                }
            });
            return Array.from(faixas);
        }
    },
    data() {
        return {
            modalDeExclusaoEstaVisivel: false,
            loading: { visivel: false },
            aporteSelecionado: null,
            mensagemVisivel: false,
            textoMensagem: '',
            estiloMensagem: '',
            tituloMensagem: '',
            aportesLocais: [...this.aportes],

        }
    },
    methods: {
        obterPercentualDaFaixa(aporte, faixa) {
            const distribuicao = aporte.DistribuicoesDoAportePorFaixa.find(d => d.NomeDaFaixa === faixa);
            return distribuicao ? distribuicao.Percentual + '%' : "-";
        },
        abrirModalDeExclusao(aporte) {
            this.aporteSelecionado = aporte;
            this.modalDeExclusaoEstaVisivel = true;
        },
        fecharModalDeExclusao() {
            this.modalDeExclusaoEstaVisivel = false;
        },
        exibirCarregamento(mensagem) {
            this.loading.visivel = true;
            this.loading.mensagem = mensagem;
        },
        esconderCarregamento() {
            this.loading.visivel = false;
            this.loading.mensagem = null;
        },
        excluirAporte() {
            let urlDeExclusaoDoAporte = `/projeto/ExcluirAporteDoMcmvCidades`;
            this.exibirCarregamento('Só um momento, estamos excluindo o aporte');

            let aporteDoMcmvCidadesParaExclusaoDto = {
                ProjetoDeSubsidioId: this.aporteSelecionado.ProjetoDeSubsidioId,
                RateioPorCidadeId: this.aporteSelecionado.RateioPorCidadeId
            };
            this.$api.post(urlDeExclusaoDoAporte, aporteDoMcmvCidadesParaExclusaoDto).then(() => {
                this.exibirMensagemDeSucesso('Aporte excluído com sucesso');
                this.removerAporteLocal();
            }).catch((error) => {
                this.tratarErro(error);
            }).finally(() => {
                this.fecharModalDeExclusao();
                this.esconderCarregamento();
            });
        },
        removerAporteLocal() {
            this.aportesLocais = this.aportesLocais.filter(a => a.RateioPorCidadeId !== this.aporteSelecionado.RateioPorCidadeId);
        },
        tratarErro(error) {
            const internalServerError = 500;
            const mensagensDeErro = error.response.status != internalServerError ? error.response.data.Message : '';
            let mensagem;

            if (mensagensDeErro)
                mensagem = mensagensDeErro.split(',').join('<br />');
            else
                mensagem = 'Desculpe, ocorreu um erro interno. Tente novamente ou contate o suporte';

            this.exibirMensagemDeErro(mensagem);
        },
        exibirMensagemDeSucesso(mensagem) {
            let estiloDaMensagem = 'sucesso';
            let tituloDaMensagem = 'Concluído'
            this.exibirMensagem(mensagem, estiloDaMensagem, tituloDaMensagem);
        },
        exibirMensagemDeErro(mensagem) {
            let estiloDaMensagem = 'erro';
            this.exibirMensagem(mensagem, estiloDaMensagem);
        },
        exibirMensagem(mensagem, estiloDaMensagem, tituloDaMensagem) {
            this.mensagemVisivel = true;
            this.textoMensagem = mensagem;
            this.estiloMensagem = estiloDaMensagem;
            this.tituloMensagem = tituloDaMensagem || '';
            setTimeout(() => { this.fecharMensagem() }, 10000);
        },
        fecharMensagem() {
            this.mensagemVisivel = false;
        }
    }
};
</script>


// WEBPACK FOOTER //
// TabelaDeAportes.vue?389a0581